import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubcategoriaService } from './subcategoria.service';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';
import { ModalGenerarAyudaComponent } from 'src/app/components/core/layouts/modal-generar-ayuda/modal-generar-ayuda.component';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ModalTiposSolicitudSubcategoriaComponent } from 'src/app/components/core/layouts/modal-tipos-solicitud-subcategoria/modal-tipos-solicitud-subcategoria.component';
import { SolicitudesService } from '../../../funcionario/solicitudes/solicitudes.service';

@Component({
	selector: 'app-subcategoria',
	templateUrl: './subcategoria.component.html',
	styleUrls: ['./subcategoria.component.scss']
})
export class SubcategoriaComponent implements OnInit {

	dataTabla: DatoPaginadoModel;
	headerSubCategoria: Array<string>;
	formSubCategoria: FormGroup;
	selectSubCategoria: any;
	tipoSolicitud: any = [];
	paginaActual: number;
	// filtros
	filtro: FormGroup;
	public isCollapsed = true;
	selectedPizzas: [];
	// Selects
	categoria: Array<any>;
	actividad_economica: Array<any>;
	habilitatiposolicitud: Array<any> = [];
	constructor(private formBuilder: FormBuilder, private subcategoriaService: SubcategoriaService,
		private modalService: NgbModal, private authService: AuthService,private dataSharedService: DataSharedService,
		private solicitudesService: SolicitudesService,
	) {
		this.getTipoSolicitud();
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
		this.createForm();
		this.consultarListas();

		this.onConsultarSubCategoria(1);

		this.selectSubCategoria = null;
		this.paginaActual = 1;

	}
	getTipoSolicitud(): void{
		this.solicitudesService
			.getTiposSolicitud()
			.subscribe(response=>{
				this.tipoSolicitud= response.data.sort((a,b) => a.tipo_solicitud_id - b.tipo_solicitud_id); ;	
			},error=>{
				this.tipoSolicitud=[];
			})
	}
	ngOnInit() {
		console.log("Auth service", this.authService.getTipoUser());
		this.headerSubCategoria = ['Subcategoria', 'Descripción Requisitos', 'Categoria',
			'Aplica Alojamiento Hospedaje', 'Aplica Documento Adjunto', 'Aplica Registro Mercantíl',
			'Aplica Resolucion Mintransporte', 'Aplica Sostenibilidad Turística ', 'Aplica Turismo Aventura',
			'Permite Cambio Tipo RNT ', 'Estado', 'Acción'];
		
	}

	cargarListaTipoSolicitudEdit(subcategoria: any) {
		this.subcategoriaService.obtenerTipoSolicitud(subcategoria.sub_categoria_id)
			.subscribe(resultado => {
				if (resultado.result) {
					this.habilitatiposolicitud = [];
					let tipoSolicitudResultado = [];
					resultado.data.forEach(element => {
						tipoSolicitudResultado.push(element.tiposolicitudid);
						this.habilitatiposolicitud.push({
							"tiposolicitudid": element.tiposolicitudid,
							"habilitatiposolicitud":  true
							});
					});
					this.formSubCategoria.controls.habilitatiposolicitud.setValue(tipoSolicitudResultado);
				}
			});
	}
	
	createForm() {
		this.formSubCategoria = this.formBuilder.group({
			descripcion: [null, Validators.required],
			categoria_id: [null, Validators.required],
			aplica_registro_mercantil: [null, Validators.required],
			aplica_alojamiento_hospedaje: [null, Validators.required],
			aplica_resolucion_mintransporte: [null, Validators.required],
			aplica_turismo_aventura: [null, Validators.required],
			aplica_sostenibilidad_turistica: [null, Validators.required],
			aplica_documento_adjunto: [null, Validators.required],
			descripcion_requisitos: [null, Validators.required],
			permite_cambio_tipo_rnt: [null, Validators.required],
			denegar_tipo_solicitud_mensaje: [null, Validators.required],
			habilitatiposolicitud: [[]],
			activo: [true],
			actividades_economicas: this.formBuilder.array([])
		});
		
		this.filtro = this.formBuilder.group({
			descripcion: [null],
			categoria_id: [null],
			aplica_registro_mercantil: [null],
			aplica_alojamiento_hospedaje: [null],
			aplica_resolucion_mintransporte: [null],
			aplica_turismo_aventura: [null],
			aplica_sostenibilidad_turistica: [null],
			aplica_documento_adjunto: [null],
			descripcion_requisitos: [null],
			permite_cambio_tipo_rnt: [null],
			activo: [null],


		});
	}

	onConsultarSubCategoria(page: number) {
		this.subcategoriaService.get({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarSubCategoria(value);
	}

	onAgregarSubCategoria() {
		this.formSubCategoria.value.habilitatiposolicitud = this.habilitatiposolicitud;
		
		
		this.subcategoriaService.create({
			...this.formSubCategoria.value, 
			activo: 1,
			actividades_economicas_ids:this.actividades_economicas.getRawValue().map(({valor}) => `'${valor}'`).join(",").toString()
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarSubCategoria(this.paginaActual);
					this.formSubCategoria.reset();
					this.resetFormArray();
					let subCategoriaIdCrear = resultado.data.sub_categoria_id;
					this.subcategoriaService.createSubcategoria( subCategoriaIdCrear , this.habilitatiposolicitud)
						.subscribe(resultado => {
							if (resultado.result) {
								this.habilitatiposolicitud = [];
								this.onConsultarSubCategoria(this.paginaActual);
								this.formSubCategoria.reset();
							}
						});
				}
			});

	}


	onOperarSubCategoria() {
		if (!this.selectSubCategoria) {
			this.onAgregarSubCategoria();
		} else {
			this.onModificarSubCategoria();
		}
	}

	onCargarSubCategoria(entry: any) {
		entry.aplica_alojamiento_hospedaje = entry.aplica_alojamiento_hospedaje ? 1 : 0;
		entry.aplica_documento_adjunto = entry.aplica_documento_adjunto ? 1 : 0;
		entry.aplica_registro_mercantil = entry.aplica_registro_mercantil ? 1 : 0;
		entry.aplica_resolucion_mintransporte = entry.aplica_resolucion_mintransporte ? 1 : 0;
		entry.aplica_sostenibilidad_turistica = entry.aplica_sostenibilidad_turistica ? 1 : 0;
		entry.aplica_turismo_aventura = entry.aplica_turismo_aventura ? 1 : 0;
		entry.permite_cambio_tipo_rnt = entry.permite_cambio_tipo_rnt ? 1 : 0;
		entry.habilitatiposolicitud = entry.habilitatiposolicitud;
		entry.activo = entry.activo ? 1 : 0;
		this.formSubCategoria.patchValue({
			...entry,
		});
		this.selectSubCategoria = entry;

		this.cargarListaTipoSolicitudEdit(this.selectSubCategoria);
		this.fillFormArray(entry.actividades_economicas_ids);
	}

	onEliminarSubCategoria(entry: any) {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then(() => {
			this.subcategoriaService.delete(entry).subscribe(resultado => {
				if (resultado.result) {
					// tslint:disable-next-line:max-line-length
					const index = this.dataTabla.items.map(function (e) { return e.sub_categoria_id; }).indexOf(entry.sub_categoria_id);
					this.dataTabla.items.splice(index, 1);
					this.formSubCategoria.reset();
					this.subcategoriaService.deleteTipoSubcategoria(  entry.sub_categoria_id)
						.subscribe(resultado => {
							if (resultado.result) {
								this.habilitatiposolicitud = [];
								this.onConsultarSubCategoria(this.paginaActual);
								this.formSubCategoria.reset();
							}
						});
				}
			});
		});
	}
	getRequestArray(array: string[]): any[]{
		let response=[];
		array.map(x=> response.push({tiposolicitudid: Number(x),habilitatiposolicitud: true}));
		return response;
	}
	onModificarSubCategoria() {
		this.subcategoriaService.update({
			actividades_economicas_ids:this.actividades_economicas.getRawValue().map(({valor}) => `'${valor}'`).join(",").toString(),
			descripcion: this.formSubCategoria.controls['descripcion'].value,
			categoria_id: this.formSubCategoria.controls['categoria_id'].value,
			aplica_registro_mercantil: this.formSubCategoria.controls['aplica_registro_mercantil'].value,
			aplica_alojamiento_hospedaje: this.formSubCategoria.controls['aplica_alojamiento_hospedaje'].value,
			aplica_resolucion_mintransporte: this.formSubCategoria.controls['aplica_resolucion_mintransporte'].value,
			aplica_turismo_aventura: this.formSubCategoria.controls['aplica_turismo_aventura'].value,
			aplica_sostenibilidad_turistica: this.formSubCategoria.controls['aplica_sostenibilidad_turistica'].value,
			aplica_documento_adjunto: this.formSubCategoria.controls['aplica_documento_adjunto'].value,

			descripcion_requisitos: this.formSubCategoria.controls['descripcion_requisitos'].value,
			permite_cambio_tipo_rnt: this.formSubCategoria.controls['permite_cambio_tipo_rnt'].value,
			denegar_tipo_solicitud_mensaje: this.formSubCategoria.controls['denegar_tipo_solicitud_mensaje'].value,
			activo: this.formSubCategoria.controls['activo'].value,
			sub_categoria_id: this.selectSubCategoria.sub_categoria_id

		}).subscribe(resultado => {
				if (resultado.result) {
					this.subcategoriaService.actualizarSubcategoria(  this.selectSubCategoria.sub_categoria_id ,this.getRequestArray(this.formSubCategoria.controls['habilitatiposolicitud'].value))
						.subscribe(resultado => {
							if (resultado.result) {
								this.habilitatiposolicitud = [];
								this.onConsultarSubCategoria(this.paginaActual);
								this.formSubCategoria.reset();
								this.resetFormArray();
							}
						});
					this.selectSubCategoria = null;
          		this.cargarListaTipoSolicitudEdit(this.selectSubCategoria);
				}
			});
	}

	onOpenModalGenerarHtml(ayuda = { descripcion_requisitos: null }) {
		const modalRef = this.modalService.open(ModalGenerarAyudaComponent,
			{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop', windowClass: 'modal-customer-xl', backdrop: 'static' });
		modalRef.componentInstance.texto_ayuda = ayuda.descripcion_requisitos || this.formSubCategoria.value.descripcion_requisitos;
		if (ayuda.descripcion_requisitos) {
			modalRef.componentInstance.editable = false;
		}
		modalRef.result.then(resultado => {
			if (!ayuda.descripcion_requisitos) {
				this.formSubCategoria.get('descripcion_requisitos').patchValue(resultado);
			}
		});
	}

	onOpenModalSubCategoria(item : any) {



		this.subcategoriaService.obtenerTipoSolicitud(item.sub_categoria_id)
			.subscribe(resultado => {
				if (resultado.result) {
					this.habilitatiposolicitud = [];
					let tipoSolicitudResultado = [];
					resultado.data.forEach(element => {
						tipoSolicitudResultado.push(`${element.tiposolicitudid}`);
						this.habilitatiposolicitud.push({
							"tipo_solicitud_id": element.tiposolicitudid,
							"habilitatiposolicitud":  element.habilitatiposolicitud,
							});
						
						
					});

					item.habilitatiposolicitud = this.habilitatiposolicitud;
					this.formSubCategoria.patchValue({
						...this.habilitatiposolicitud,
					});
					this.selectSubCategoria = item;
					const modalRef = this.modalService.open(ModalTiposSolicitudSubcategoriaComponent,
						{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop', windowClass: 'modal-customer-lg', backdrop: 'static' });
					modalRef.componentInstance.habilitatiposolicitud = this.habilitatiposolicitud;
					modalRef.componentInstance.tipoSolicitud = this.tipoSolicitud;;
				}
			});


		//this.cargarListaTipoSolicitudEdit(this.selectSubCategoria);
	}

	consultarListas() {
		this.subcategoriaService.getCategoria().subscribe(resultado => {
			if (resultado.data) {
				this.categoria = resultado.data;
			}
		});
	}
	onChangeSearch(valor: string) {
		this.subcategoriaService.obtenerActividadesEconomicas({valor:valor==null?'':valor}).subscribe(resultado =>{
			if(resultado.data){
				this.actividad_economica = resultado.data;
				this.removeElementsCurrentlySelecteds();
			}else{
				this.actividad_economica=[];
			}
		})
	}
	
	get(): void{
	   this.onChangeSearch('');
	   
	}

	filtrar() {
		this.paginaActual = 1;
		this.onConsultarSubCategoria(1);
	}

	limpiar() {
		this.filtro.reset();
		this.filtrar();
	}
	limpiaSubcategoria() {
		this.formSubCategoria.reset();
		this.selectSubCategoria = null;
		this.createForm();
	}


	selectOpt($event) {
		const index = this.habilitatiposolicitud.findIndex(el => el['tiposolicitudid'] === parseInt($event.option.value,10));
		if ($event.option.selected) {
			this.habilitatiposolicitud.push({
				"tiposolicitudid": $event.option.value,
				"habilitatiposolicitud": $event.option.selected
				});
		} else {
			this.habilitatiposolicitud.splice(index, 1);
		}
	}
	addActividadEconomica(value?: any): void {
		const lessonForm = this.formBuilder.group({
			valor: [{value:(value != undefined)?value:'',disabled:value != undefined}, Validators.required]
		});
		this.actividades_economicas.push(lessonForm);
	}
	deleteActividadEconomica(lessonIndex: number) {
		this.actividades_economicas.removeAt(lessonIndex);
	}
	get actividades_economicas() {
		return this.formSubCategoria.controls["actividades_economicas"] as FormArray;
	}
	removeElementsCurrentlySelecteds(): void{
		this.actividades_economicas.getRawValue().forEach(actividad=>{
			this.actividad_economica=this.actividad_economica.filter(act=> act.codigo_actividad_economica != actividad.valor);
		});
	}
	onSelectActividadEconomica(indexFormArray: number):void{
		this.actividades_economicas.at(indexFormArray).disable();
	}
	clearFormArray(): void{
		while (this.actividades_economicas.length !== 0) {
			this.actividades_economicas.removeAt(0)
		}
	}
	fillFormArray(value: string): void{
		this.clearFormArray();
		if(value != undefined){
			let arrayValue = value.split(',');
			arrayValue.forEach((item,index)=>{
				if(index === 0) this.actividades_economicas.removeAt(0);
				this.addActividadEconomica(item);
			})
		}else{
			this.actividades_economicas.setValue([]);
		}
	}
	resetFormArray(): void{
		while (this.actividades_economicas.length) {
			this.actividades_economicas.removeAt(0);
		 }
	}
}
